var CartDrawerRecommendations = class extends HTMLElement {
    static recommendationsCache = {};
  
    constructor() {
      super();
      // this._abortController = new AbortController();
    }
  
    connectedCallback() {    
      // Show loading state initially
      this.showLoadingState();
      // Initial load of recommendations
      this.loadRecommendations();
    }
  
    disconnectedCallback() {
      // this._abortController.abort();
    }
  
    /**
     * Show loading state
     */
    showLoadingState() {
      const loadingElement = this.querySelector('.cart__drawer-upsells-loading');
      if (loadingElement) {
        loadingElement.style.display = 'flex';
      }
    }

    /**
     * Hide loading state
     */
    hideLoadingState() {
      const loadingElement = this.querySelector('.cart__drawer-upsells-loading');
      if (loadingElement) {
        loadingElement.style.display = 'none';
      }
    }

    /**
     * Load product recommendations based on the first item in the cart
     */
    async loadRecommendations() {
      const sectionId = this.getAttribute('section-id');
      const productId = this.getAttribute('product-id');
      
      try {
        if (!productId || !sectionId) {
          // this.hidden = true;
          return;
        }
  
        // Use cached request if available or create a new one
        const cacheKey = `${productId}-${sectionId}`;
        if (!CartDrawerRecommendations.recommendationsCache[cacheKey]) {
          CartDrawerRecommendations.recommendationsCache[cacheKey] = fetch(
            `${Shopify.routes.root}recommendations/products?product_id=${productId}&limit=10&section_id=${sectionId}`
          );
        }
  
        const response = await CartDrawerRecommendations.recommendationsCache[cacheKey];
        const text = await response.clone().text();      
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        
        const recommendationsContent = tempDiv.querySelector('.cart__drawer-upsells-recommendations');
        
        if (recommendationsContent && recommendationsContent.innerHTML.trim() !== '') {
          this.innerHTML = recommendationsContent.innerHTML;
          this.hideLoadingState();
          setTimeout(() => {
            if (document.querySelector('.cart__drawer')) {
              document.querySelector('.cart__drawer').classList.remove('cart__drawer--updating-recs');
            }
          }, 350);        
        } else {
          this.hideLoadingState();
        }
      } catch (error) {
        console.error('Error loading recommendations:', error);
        this.hideLoadingState();
        setTimeout(() => {
          if (document.querySelector('.cart__drawer')) {
            document.querySelector('.cart__drawer').classList.remove('cart__drawer--updating-recs');
          }
        }, 350);    
      }
    }
  }
  
  if (!window.customElements.get("cart-drawer-recommendations")) {
    window.customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);
  }